"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewGroupBy = exports.ViewColorBy = exports.ServiceCancellation = exports.ShiftCancellation = exports.JobPayType = exports.DayNumbersArray = exports.GridExceptions = void 0;
class GridExceptions {
    services;
    shifts;
    shiftGaps;
    constructor() {
        this.services = {};
        this.shiftGaps = {};
        this.shifts = {};
    }
    add(index, key, exception) {
        const obj = this[index][key];
        if (obj) {
            obj.add(exception);
        }
        else {
            this[index][key] = new Set([exception]);
        }
    }
    addService(key, exception) {
        this.add('services', key, exception);
    }
    addShift(key, exception) {
        this.add('shifts', key, exception);
    }
    addShiftGap(key, exception) {
        this.add('shiftGaps', key, exception);
    }
}
exports.GridExceptions = GridExceptions;
exports.DayNumbersArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
var JobPayType;
(function (JobPayType) {
    JobPayType[JobPayType["PayByShift"] = 1] = "PayByShift";
    JobPayType[JobPayType["PayByTask"] = 2] = "PayByTask";
})(JobPayType || (exports.JobPayType = JobPayType = {}));
var ShiftCancellation;
(function (ShiftCancellation) {
    ShiftCancellation[ShiftCancellation["NotCancelled"] = 0] = "NotCancelled";
    ShiftCancellation[ShiftCancellation["CancelledUnpaid"] = 1] = "CancelledUnpaid";
    ShiftCancellation[ShiftCancellation["CancelledPaid"] = 2] = "CancelledPaid";
})(ShiftCancellation || (exports.ShiftCancellation = ShiftCancellation = {}));
var ServiceCancellation;
(function (ServiceCancellation) {
    ServiceCancellation[ServiceCancellation["NotCancelled"] = 0] = "NotCancelled";
    ServiceCancellation[ServiceCancellation["CancelledCharged"] = 1] = "CancelledCharged";
    ServiceCancellation[ServiceCancellation["CancelledNotCharged"] = 2] = "CancelledNotCharged";
})(ServiceCancellation || (exports.ServiceCancellation = ServiceCancellation = {}));
var ViewColorBy;
(function (ViewColorBy) {
    ViewColorBy[ViewColorBy["ShiftTemplate"] = 0] = "ShiftTemplate";
    ViewColorBy[ViewColorBy["Area"] = 1] = "Area";
    ViewColorBy[ViewColorBy["ServiceType"] = 2] = "ServiceType";
    ViewColorBy[ViewColorBy["ServiceAssigned"] = 3] = "ServiceAssigned";
    ViewColorBy[ViewColorBy["SCHADShiftGroup"] = 4] = "SCHADShiftGroup";
})(ViewColorBy || (exports.ViewColorBy = ViewColorBy = {}));
var ViewGroupBy;
(function (ViewGroupBy) {
    ViewGroupBy[ViewGroupBy["NoGrouping"] = 0] = "NoGrouping";
    ViewGroupBy[ViewGroupBy["Area"] = 1] = "Area";
    ViewGroupBy[ViewGroupBy["Classification"] = 2] = "Classification";
    ViewGroupBy[ViewGroupBy["ShiftTemplate"] = 3] = "ShiftTemplate";
    ViewGroupBy[ViewGroupBy["ServiceType"] = 4] = "ServiceType";
})(ViewGroupBy || (exports.ViewGroupBy = ViewGroupBy = {}));
//# sourceMappingURL=types-roster.js.map